import { toast } from "react-toastify";
import i18n from "../services/i18n";

export const showMessageSuccessFromAssets = (assetNode: string) => {
  const message = i18n.t(assetNode);
  toast.success(message);
};
